import { Stack, Typography } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';
import { isEmpty } from '@/shared/util';

import { usePatientPermissionsAndDetails } from './use-header-permissions.hook';

export function PatientAlias() {
  const { patient } = useStudyGuard();
  const { showAlias } = usePatientPermissionsAndDetails();

  if (!showAlias) {
    return null;
  }

  if (isEmpty(patient?.fake_lastname) || isEmpty(patient?.fake_firstname)) {
    return null;
  }

  return (
    <Stack alignment="center" className="border-r-2 py-1 pr-2">
      <Typography
        className="text-inherit"
        translationKey="FCT.REPORTING.HEADER.PATIENT.ALIAS"
        variant="paragraph-sm"
      />
      <Typography
        className="px-1 text-inherit"
        translationKey="FCT.REPORTING.HEADER.PATIENT.ALIAS_NAME"
        values={{ firstname: patient.fake_firstname, lastname: patient.fake_lastname }}
        variant="paragraph-sm"
      />
    </Stack>
  );
}
